import { Link, useNavigate } from 'react-router-dom';

import { ROUTES } from '../Routes';
import { usePageTitle } from '../hooks/usePageTitle'
import { useState } from 'react';

const RegisterPage = () => {
    usePageTitle('Create Account | Quinexa')
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        password: '',
        confirmPassword: ''
    });

    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleRegister = (e) => {
        e.preventDefault();
        setError('');

        if (formData.password !== formData.confirmPassword) {
            setError('Passwords do not match!');
            return;
        }

        const existingUsers = JSON.parse(localStorage.getItem('users')) || [];

        const userExists = existingUsers.find(user => user.email === formData.email);
        if (userExists) {
            setError('This email is already registered.');
            return;
        }

        const newUser = {
            id: Date.now(),
            name: formData.name,
            email: formData.email,
            password: formData.password,
            credits: 1000
        };

        const updatedUsers = [...existingUsers, newUser];
        localStorage.setItem('users', JSON.stringify(updatedUsers));

        alert('Account created successfully! You received 1,000 credits.');
        navigate(ROUTES.LOGIN);
    };

    return (
        <main className="main auth-page">
            <div className="auth-container">
                <div className="auth-card">
                    <h1 className="auth-title">Create Account</h1>
                    <p className="auth-subtitle">Get 1,000 free starter Credits when you sign up</p>

                    {/* Hata mesajı varsa göster */}
                    {error && <div className="error-message" style={{ color: 'red', marginBottom: '10px' }}>{error}</div>}

                    <form id="registerForm" className="auth-form" onSubmit={handleRegister}>
                        <div className="form-group">
                            <label htmlFor="name">Display Name</label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                placeholder="Choose a display name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="email">Email</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                placeholder="you@example.com"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="password">Password</label>
                            <input
                                type="password"
                                id="password"
                                name="password"
                                placeholder="Create a password"
                                value={formData.password}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="confirmPassword">Confirm Password</label>
                            <input
                                type="password"
                                id="confirmPassword"
                                name="confirmPassword"
                                placeholder="Confirm your password"
                                value={formData.confirmPassword}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <button type="submit" className="submit-btn">Create Account</button>
                    </form>

                    <div className="auth-footer">
                        <p>Already have an account? <Link to={ROUTES.LOGIN}>Sign in</Link></p>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default RegisterPage;